module.exports = __webpack_public_path__ + "static/media/AlexCheng.7dbeae0b.jpg";